import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import WWBagelsProduct from 'models/WWBagelsProduct'
import React, { useContext, useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState } from './constants'
import Switch from 'react-switch'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { isNotNumericDecimal } from 'context/Utilities'

const WWBagelsPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { onChange, setSwitch, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const { category, subCategory, Size, WholeWheatCert } = current
      setPackaging({
        category,
        subCategory,
        Size,
        WholeWheatCert,
      })
    } else if (!updating) {
      setCurrent(WWBagelsProduct)
    }
    console.log(
      'current inside useEffect for WWBagelsPackage: ' + JSON.stringify(current)
    )
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (current) {
      setPackaging({ ...packaging, ...current })
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs="12" md="6" className="mt-2">
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="Size"
            placeholder={'12 - 48 ounces'}
            control={methods.control}
            rules={{
              required: '⚠ Size is required.',
              validate: Size => Size >= 12 && Size <= 48,
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Size"
              message={'⚠ Size must be between 12 - 48 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>
              I certify that this product has “100% Whole Wheat” printed on the
              front label. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="WholeWheatCert"
            id="WholeWheatCert"
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            control={methods.control}
            defaultValue={packaging.WholeWheatCert}
            rules={{
              validate: WholeWheatCert => WholeWheatCert === true,
            }}
          />
          <br />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="WholeWheatCert"
              message={
                "⚠ You must certify that this product has “100% Whole Wheat” printed on the front label. If the product doesn't contain the label, it cannot be authorized."
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default WWBagelsPackage
